import { FC, useMemo } from "react";
import { useSportsbookConfig } from "@finbackoffice/site-core";
import { AssetsDirectory } from "@finbackoffice/enums";
import classNames from "classnames";
import { useSportFeedType } from "hooks";
import { Svg } from "../svg/Svg";
import styles from "./sport-icon.module.sass";

type IProps = {
    sportId: number;
};

const SportIcon: FC<IProps> = ({ sportId }) => {
    const { isSportsbookFlat } = useSportsbookConfig();
    const { isBCFeed } = useSportFeedType();

    const iconsDirectory = useMemo(() => {
        let path = "";

        if (isBCFeed) {
            path += `${AssetsDirectory.BCFeed}/`;
        } else {
            path += `${AssetsDirectory.BRFeed}/`;
        }

        if (isSportsbookFlat) {
            path += AssetsDirectory.SportIconsFlat;
        } else {
            path += AssetsDirectory.SportIcons;
        }

        return path;
    }, [isBCFeed, isSportsbookFlat]);

    return (
        <Svg
            src={`/${AssetsDirectory.Common}/${iconsDirectory}/${sportId}.svg`}
            className={classNames(styles.sportIcon, "svg-sport-icon")}
            loader
        />
    );
};

export default SportIcon;
